import {
LuShieldCheck,
LuDatabase,
LuLock,
LuServer,
LuUserCheck
} from "react-icons/lu"
import { useState,useEffect } from "react"
import { useLocation } from "react-router-dom"
import "./Security.css"

function Security(){

const [loaded,setLoaded]=useState(false)

const location = useLocation()

useEffect(()=>{

window.scrollTo(0,0)

setLoaded(false)

const timer=setTimeout(()=>{
setLoaded(true)
},100)

return()=>clearTimeout(timer)

},[location.pathname])

return(

<section className={`security ${loaded?"loaded":""}`}>

<div className="security-header">

<h1>
Security & <span>Data Protection</span>
</h1>

<p>
SLUZ is designed with a strong focus on protecting student data.  
All information is securely handled and used only to generate personalized learning roadmaps for students.
</p>

</div>


<div className="security-dotted">

<p>
This platform is intentionally transparent about how user data is handled.  
For authentication and student related information we use <strong>Firebase Authentication and Firestore</strong>.  
Learning feed content and roadmap data are stored in an <strong>open-source GitHub repository</strong> so the system remains transparent and maintainable for this academic project.
</p>

</div>


<div className="security-grid">

<div className="security-card">

<LuUserCheck className="security-icon green"/>

<h3>Data Collection</h3>

<p>
SLUZ collects limited information such as name, email, branch, academic year and career goal preferences in order to generate personalized learning guidance.
</p>

</div>


<div className="security-card">

<LuDatabase className="security-icon blue"/>

<h3>Data Storage</h3>

<p>
User authentication details, activity logs and screentime insights are securely stored using Firebase Authentication and Firestore database infrastructure.
</p>

</div>


<div className="security-card">

<LuLock className="security-icon purple"/>

<h3>Privacy Protection</h3>

<p>
User data is not sold or shared with third parties. Information is only used to personalize the learning experience and improve platform features.
</p>

</div>


<div className="security-card">

<LuServer className="security-icon orange"/>

<h3>Content Infrastructure</h3>

<p>
Educational feed content used in SLUZ is maintained inside an open-source GitHub repository bucket, allowing structured updates and transparent version control.
</p>

</div>

</div>


<div className="security-panel">

<h3>
<LuShieldCheck className="panel-icon"/> Responsible Use
</h3>

<p>
This platform is developed for educational and presentation purposes.  
The goal of SLUZ is to guide students through structured career development paths while maintaining safe data practices and transparent infrastructure usage.
</p>

</div>

</section>

)

}

export default Security